<!-- removed backgound color from below and addedc class
[style.background-color]="getColor()"
[style.border-color]="getColor('borderColor')" -->
<span class="switch"
      [class.checked]="checked"
      [class.disabled]="disabled"
      [class.switch-large]="size === 'large'"
      [class.switch-medium]="size === 'medium'"
      [class.switch-small]="size === 'small'"
      [class.switch-labeled]="!!labelOn || !!labelOff"
      [ngClass]="getColor()"
      
>
  <input type="checkbox" id="enabled" name="enabled" [checked]="checked" style="display: none;" aria-invalid="false">
  <small [ngClass]="getColor('switchColor')"></small>
  <!-- <small [style.background]="getColor('switchColor')"></small> -->
  <span class="switch-text" *ngIf="!!labelOn || !!labelOff">
    <span class="on">{{labelOn}}</span>
    <span class="off">{{labelOff}}</span>
  </span>
</span>
